angular.module('impactx.basketLink').directive('ixPrice', function () {
    return {
        scope: {
            price : '=',
            secondPrice: "=",
            coAmountFillLabel: '@',
            minAmountLabel: '@',
            stepSizeLabel: '@',
            perLabel: '@',
            isAdditional: '=',
            showStepSize: '='
        },
        restrict:'E',
        templateUrl: 'shared/basketlink/templates/price.html',
        transclude: true,
        controller: 'PriceCtrl',
        controllerAs: "priceCtrl"
    };
});